<template>
  <div class="card" :class="verticalOrientationCheck">

    <div class="card-body" :class="verticalOrientationCheck">
      <div class="card-header">
        <img class="ct-logo"
             src="https://media-triangle.canadiantire.ca/banners/category-content/2022/triangle-ca-odp-2022-/canadian-tire-desktop-offer-card.svg?im=whresize&wid=96&hei=36"
             alt="ct-logo"/>
        <img class="badge-image"
             :src="badgeImage"
             alt="badge"/>
      </div>

      <div class="card-image">
        <img :src="offerImage" alt="Product Image">
      </div>

      <p class="card-description">
        {{ description }}
      </p>

      <p class="card-validity">{{ content.offerEnds }}: {{ offerEnds }} </p>
    </div>

    <div class="card-footer" :class="verticalOrientationCheck">
      <div
          :class="{noClick : offerStatus==='Activated' || offerStatus==='Redeemed' || offerStatus==='Activée' || offerStatus==='Échangée' , activateBtn: offerStatus==='Activate' || offerStatus==='Activer'}"
          @click="handleOfferClick()">
        <img :src="icon" height="11px" :alt="offerStatus" />
        <span>&nbsp;{{ toTitleCase(offerStatus) }}</span>
      </div>
    </div>

  </div>

</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";
export default {
  name: "OffersCard",
  props: {
    offer: {
      type: Object,
      required: true,
    }
  },

  computed:{
    ...mapGetters(["content", "language"]),
    ...mapGetters('screen', ["flyerOrientation","displayMode"]),

    badgeImage(){
      return this.offer.badgeImageUrl || '';
    },
    description(){
      return this.offer.description || '';
    },
    offerImage(){
      return this.offer.imageUrl || '';
    },
    icon(){
      return this.offer.offerStatus === 'ACTIVATED' ? '/icons/icon-check-green.svg' :  this.offer.offerStatus === 'ACTIVATED' ? '/icons/icon-plus.svg' : this.offer.offerStatus === 'REDEEMED' ? '/icons/icon-gift.svg' : '/icons/icon-plus.svg'
    },
    offerStatus(){
      if(this.offer.offerStatus==='ACTIVATE') return this.content.activate
      else if(this.offer.offerStatus==='ACTIVATED') return this.content.activated
      else if(this.offer.offerStatus==='REDEEMED') return this.content.redeemed
      else return ''
    },
    offerEnds(){
      return moment(this.offer.offerEndDate,"MMDDYYYY").format("MM/DD/YYYY")
    },
    verticalOrientationCheck(){
      return {
        'dVertical': this.flyerOrientation==='vertical' && (this.displayMode==='desktop' || this.displayMode==='tablet'),
        'vertical': this.flyerOrientation==='vertical' && this.displayMode==='mobile'
      }
    }
  },
  methods:{
    toTitleCase(str) {
     return str.toLowerCase().replace(/^\S|\s\S/g, (match) => match.toLocaleUpperCase('fr-FR'));
    },
    handleOfferClick(){
      this.language==='en'?  window.open('https://www.canadiantire.ca/en/my-account/weekly-offers.html') : window.open('https://www.canadiantire.ca/fr/mon-compte/offres-hebdomadaires.html')
    }
  }
}
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 3px;
  background-color: #fff;
  min-height: 12rem;
  height: 98%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

  .card-body {
    border-bottom: 0.5px solid lightgrey;
    flex: 8.5;
  }

.card-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.card-header .ct-logo{
  max-width:64px;
  padding-left: 0.2em;
}
.card-header .badge-image{
  max-height: 1em;
  width:auto;
  margin-right: 3px;
}

.card-image {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 88px;
  width: 100%;
  margin: 0 auto;
}

.card-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.card-description{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-height: 1.2em;
  max-height: 3.2em;
  font-size: 10px;
  padding: 0.8em;
}

.card-validity{
  padding: 0.8em;
  font-size:10px;
  color:#830b2c;
}

.card-footer {
  font-size: 11px;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1.5;
}

.card-footer .noClick {
  pointer-events: none;
  margin: 3px auto;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-footer .activateBtn{
  background: #417f86;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  min-height: 25px;
  color: white;
  cursor: pointer;
  border-radius: 5px;
  margin: 3px auto;
}
.card-footer .activateBtn:hover{
  filter:brightness(90%);
  text-decoration: underline;
}

.card .vertical{
  height:206px;
}
.card.dVertical{
  height:320px;
}
</style>